import { cn } from '../utilitarios/cn'

/**
 * Placeholder de carregamento. Preferido ao girador quando a forma do conteúdo é
 * conhecida (tabela, cartão de indicador): reduz o salto de layout quando os
 * dados chegam.
 */
export function Esqueleto({ className }: { className?: string }) {
  return (
    <div
      aria-hidden="true"
      className={cn('animate-pulse rounded-md bg-superficie-3', className)}
    />
  )
}

export function EsqueletoTexto({ linhas = 3, className }: { linhas?: number; className?: string }) {
  return (
    <div className={cn('space-y-2', className)}>
      {Array.from({ length: linhas }, (_, indice) => (
        <Esqueleto
          key={indice}
          className={cn('h-3.5', indice === linhas - 1 ? 'w-2/3' : 'w-full')}
        />
      ))}
    </div>
  )
}
